var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"width":_vm.width,"max-width":_vm.width,"alt":"Ehitussektor","src":_vm.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }